import initialState from '../initialstate';
import * as types from '../../actions/actiontypes';

export default function milestonesReducer(state = initialState, action) {
	switch (action.type) {
		case types.GET_MILESTONES_BUILD_TASKS: {
			let response = action.response.taskGroups;
			if (response && response[0] && response[0].tasks) {
				return [...response[0].tasks];
			}
			return [];
		}
		case types.CLEAN_MILESTONES_BUILD_TASKS: {
			return [];
		}
		default: {
			return state;
		}
	}
}
